export function isHeadOfficeUser(role = '') {
    const organizationRoles = ['HEAD_OFFICE', 'ORGANIZATION'];

    return organizationRoles.includes(role);
}

export function isOrganizatorUser(role = '') {
    const organizatorRole = ['ORGANIZATION_USER'];

    return organizatorRole.includes(role);
}